'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @fileoverview 类型相关
 * @author kirkzheng
 */

var class2type = {};
'Boolean Number String Function Array Date RegExp Object Error'.split(' ').map(function (name) {
    class2type['[object ' + name + ']'] = name.toLowerCase();
    return name;
});

var toString = Object.prototype.toString;

/**
 * 获取类型
*/
var type = exports.type = function type(obj) {
    if (obj == null) {
        return String(obj);
    }
    var typeName = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
    // Support: Safari <= 5.1 (functionish RegExp)
    return typeName === 'object' || typeName === 'function' ? class2type[toString.call(obj)] || 'object' : typeName;
};

/**
 * 是否数组
*/
var isArray = exports.isArray = function isArray(val) {
    return toString.call(val) === '[object Array]';
};

/**
 * 是否数组
*/
var isString = exports.isString = function isString(val) {
    return typeof val === 'string';
};

/**
 * 是否数字
 */
var isNumber = exports.isNumber = function isNumber(val) {
    return typeof val === 'number';
};

/**
 * 是否undefined
*/
var isUndefined = exports.isUndefined = function isUndefined(val) {
    return typeof val === 'undefined';
};

/**
 * 是否Object
 */
var isObject = exports.isObject = function isObject(val) {
    return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
};

/**
 * 是否Date
 */
var isDate = exports.isDate = function isDate(val) {
    return toString.call(val) === '[object Date]';
};

/**
 * 是否file
 */
var isFile = exports.isFile = function isFile(val) {
    return toString.call(val) === '[object File]';
};

/**
 * 是否函数
 */
var isFunction = exports.isFunction = function isFunction(val) {
    return toString.call(val) === '[object Function]';
};

/**
 * 验证是否为空对象
 * @param {Object} obj
 * @return {boolean}
 */
var isEmptyObject = exports.isEmptyObject = function isEmptyObject(obj) {
    var name = '',
        result = true;

    for (name in obj) {
        if (name) {
            result = false;
        }
    }
    return result;
};

/**
 * 判断是否为空值
 * 可以判断空数组,对象, 字符串, null undefined 等类型
 * @param value
 * @returns {boolean}
 */
var isEmptyValue = exports.isEmptyValue = function isEmptyValue(value) {
    var valueType = type(value),
        isEmpty = false;
    switch (valueType) {
        case 'array':
        case 'string':
            isEmpty = value.length === 0;
            break;
        case 'object':
            isEmpty = isEmptyObject(value);
            break;
        case 'null':
        case 'undefined':
            isEmpty = true;
            break;
    }
    return isEmpty;
};

exports.default = {
    type: type,
    isArray: isArray,
    isString: isString,
    isNumber: isNumber,
    isUndefined: isUndefined,
    isObject: isObject,
    isDate: isDate,
    isFile: isFile,
    isFunction: isFunction,
    isEmptyObject: isEmptyObject,
    isEmptyValue: isEmptyValue
};